import React, { useEffect, useRef, useState } from 'react';
import styles from './WhyChooseUs.module.css';

const WhyChooseUs: React.FC = () => {
  const [visibleItems, setVisibleItems] = useState<number[]>([]);
  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const listItems = Array.from(entry.target.querySelectorAll('li'));
            listItems.forEach((item, index) => {
              setTimeout(() => {
                setVisibleItems(prev => {
                  if (!prev.includes(index)) {
                    return [...prev, index];
                  }
                  return prev;
                });
              }, index * 200);
            });
          }
        });
      },
      { threshold: 0.3 }
    );

    if (listRef.current) {
      observer.observe(listRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className={`${styles.whyChooseUsSection} trowel-background`}>
      <div className={styles.whyChooseUsContainer}>
        <div className={styles.whyChooseUsContent}>
          <h1>Why Choose Us?</h1>
          <div className={styles.benefitsList}>
            <ul ref={listRef}>
              <li className={visibleItems.includes(0) ? styles.slideInVisible : styles.slideInHidden}>
                Locally owned & operated in Revelstoke
              </li>
              <li className={visibleItems.includes(1) ? styles.slideInVisible : styles.slideInHidden}>
                Clean, precise installations every time
              </li>
              <li className={visibleItems.includes(2) ? styles.slideInVisible : styles.slideInHidden}>
                Transparent quoting and no surprises
              </li>
              <li className={visibleItems.includes(3) ? styles.slideInVisible : styles.slideInHidden}>
                Flexible scheduling to work around your needs
              </li>
              <li className={visibleItems.includes(4) ? styles.slideInVisible : styles.slideInHidden}>
                Friendly, down-to-earth service
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;